import styled, { css } from 'styled-components';

import { OverviewCTALinkText } from '@/src/components/OverviewSection';
import { tabletBreakpoint } from '@/src/domains/shared/breakpoints';

export const ReadMoreWrapper = styled.div`
  display: flex;
  ${tabletBreakpoint(css`
    flex-direction: column;
    align-items: flex-start;
    gap: 30px;
  `)}
  margin: 50px 0 150px;
`;

export const ReadMoreTitle = styled.div`
  ${({ theme }) => theme.typography.bodyLeadBold}
  color: var(--colors-bayoux);
  margin-bottom: 6px;

  > * {
    font-size: inherit;
    font-weight: inherit;
    margin: inherit;
  }
`;

export const ReadMoreLinksWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  & span {
    justify-content: flex-start;
  }
`;

export const ReadMoreLink = styled(OverviewCTALinkText)`
  ${({ theme }) => theme.typography.titleXS}
  font-weight: 400;
  color: var(--colors-irisBlue);

  > * {
    font-size: inherit;
    font-weight: inherit;
    margin: inherit;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 30px;
  gap: 10px;
`;
